
import React from 'react';
import { connect } from 'react-redux';
import LoggedOut from './LoggedOut';
import * as actions from '../store/actions/index';
import './LoggedOut.css'
import { logoutActivityTrack } from '../common/commonService';
class MyGameLogout extends React.Component {
    
    logout = (loginPath) => {
        console.log("logout loginPath", loginPath)
        if (loginPath === 'MyGame') this.props.history.push('/mygamelogin')
        // else if (loginPath === 'PartyPoker') this.props.history.push('/')
        else if(loginPath === 'Brand') this.props.history.push('/brandLogin')
        else this.props.history.push('/loggedOut')
    }

    componentDidMount = async () => {
        await this.props.resetStore()
        const loginPath = localStorage.getItem('loggedInType')
        await logoutActivityTrack()
        this.logout(loginPath)
    }

    render() {
        return (
            <LoggedOut />
        )
    }
}
const mapDispatchToProps = dispatch => {
    return {
        resetStore: () => dispatch(actions.resetStore()),
    }
};
export default connect(null, mapDispatchToProps)(MyGameLogout)


/** WEBPACK FOOTER **
 ** ./src/components/MyGameLogout.js
 **/